<template>
	<div class="contact">
		<back-to></back-to>
		<section class="contact_list" v-for="(item,index) in enrolls" :key="index">
			<h2>{{item.enrollName}}（{{buyNum[index].num}}）</h2>
			<span v-for="(val,key) in buyNum[index].num" :key="key"
				@click="enrollsIndex = index,buyNumIndex = key,orderContactShow = true,select()">
				<label for="" v-if="buyNum[index].info.length > 0 && buyNum[index].info[key]">
					<p>{{buyNum[index].info[key].name}}</p>
					<p>{{buyNum[index].info[key].tel}}</p>
				</label>
				<label for="" v-else>游客{{key+1}}</label>
				<font>></font>
			</span>
		</section>
		<div class="travelerForm-b" @click="onSubmit">保存</div>
		<!-- 联系人信息 -->
		<van-popup class="orderPopupt" v-model="orderContactShow" round position="bottom">
			<div class="orderPopup-sure">
				<span @click="orderContactShow = false">取消</span>
				<span @click="orderContactShow = false">确认</span>
			</div>
			<div class="orderPopup-list">
				<ul>
					<li v-for="(item,index) in travelerList" :key="index" @click="selecTorderContact(index)">
						<p v-for="(map,sort) in item.templatTag" :key="sort" v-if="map.isMain">{{map.tagValue}}</p>
						<span class="orderPopup-lists">
							<img v-if="item.checked"
								src="https://sweetour-pic.obs.myhwclouds.com/sweetour-newPlaceOrder-image_08.png"
								alt="">
							<font v-if="!item.checked" class="select-false"></font>
						</span>
					</li>
				</ul>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		mapGetters,
		mapMutations
	} from 'vuex'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'person',
		components: {
			BackTo
		},
		data() {
			return {
				enrolls: [],
				buyNum: [],
				orderContactShow: false,
				travelerList: [],
				enrollsIndex: 0,
				buyNumIndex: 0
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {
			this.buyNum = JSON.parse(this.$route.query.buyNum)
			this.enrolls = JSON.parse(this.$route.query.enrolls)
		},
		mounted() {
			this.getTravelerList()
		},
		methods: {
			...mapMutations('account', ['setBuyNum']),
			onSubmit() {
				this.setBuyNum(this.buyNum)
				this.$router.back()
			},
			getTravelerList() {
				this.$_getNew(
					this.$severOrder + '/Order_UserTemplateBase/GetByUserId?Id=' + this.userInfo.userId, {}
				).then(res => {
					for (let i = 0; i < res.result.length; i++) {
						res.result[i].isSelect = false
						res.result[i].checked = false
					}
					this.travelerList = res.result
				})
			},
			select() {
				var index = this.travelerList.findIndex(item => item.checked == true)
				if (index > -1) {
					this.travelerList[index].checked = !this.travelerList[index].checked
				}
			},
			selecTorderContact(e) {
				var selectLength = this.travelerList.filter(item => item.checked == true)
				if (selectLength < 1) {
					this.travelerList[e].checked = !this.travelerList[e].checked
				} else {
					var index = this.travelerList.findIndex(item => item.checked == true)
					this.travelerList[index].checked = !this.travelerList[index].checked
					this.travelerList[e].checked = !this.travelerList[e].checked
				}
				var info = {
					'tel': this.travelerList[e].templatTag.filter(item => item.tagName == '手机号')[0].tagValue,
					'name': this.travelerList[e].templatTag.filter(item => item.tagName == '姓名')[0].tagValue
				}
				// this.buyNum[this.enrollsIndex].info[this.buyNumIndex].tel = this.travelerList[e].templatTag.filter(item => item.tagName ==
				// 	'手机号')[0].tagValue
				// this.buyNum[this.enrollsIndex].info[this.buyNumIndex].name = this.travelerList[e].templatTag.filter(item => item.tagName ==
				// 	'姓名')[0].tagValue
				this.buyNum[this.enrollsIndex].info[this.buyNumIndex] = info
			}

		}
	}
</script>

<style>
	.contact_list {
		width: 100%;
		border-bottom: 20px solid #f7f7f7;
		padding: 28px;
		box-sizing: border-box;
	}

	.contact_list h2 {
		font-size: 28px;
		color: #333;
		padding-bottom: 20px;
	}

	.contact_list span {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-top: 2px solid #f7f7f7;
	}

	.contact_list label {
		margin-top: 24px;
		margin-bottom: 18px;
		font-size: 28px;
		color: #333;
	}

	.contact_list p {
		font-size: 24px;
	}

	.contact .orderPopupt {
		width: 100%;
		padding: 30px 0;
		height: 600px;
	}

	.contact .orderPopup-sure {
		display: flex;
		justify-content: space-between;
		width: 100%;
		font-size: 30px;
		border-bottom: 1px solid #f2f2f2;
		padding: 0 70px 30px 70px;
		box-sizing: border-box;
	}

	.contact .orderPopup-sure span:first-child {
		color: #ccc;
	}

	.contact .orderPopup-sure span:last-child {
		color: #ff6d00;
	}

	.contact .orderPopup-add {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.contact .orderPopup-add span {
		margin-top: 30px;
		background: #f5f5f5;
		height: 80px;
		font-size: 40px;
		color: #ff6d00;
		text-align: center;
		line-height: 80px;
		border-radius: 5px;
		width: 100%;
	}

	.contact .orderPopup-list {
		width: 100%;
		padding: 10px 50px;
		box-sizing: border-box;
	}

	.contact .orderPopup-list li {
		display: flex;
		align-items: center;
		border-bottom: #f5f5f5 solid 1px;
		font-size: 30px;
		color: #333;
		height: 100px;

	}

	.contact .orderPopup-list li p {
		margin-right: 30px;
	}

	.contact .orderPopup-list img {
		width: 28px;
		height: 28px;
	}

	.contact .select-false {
		display: block;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		border: 1px solid #666;
		box-sizing: border-box;
	}

	.contact .orderPopup-lists {
		margin-left: auto;
	}

	.contact .travelerForm-b {
		width: 710px;
		margin: 40px auto;
		height: 90px;
		line-height: 90px;
		text-align: center;
		background: #F9902F;
		box-shadow: 0px 3px 10px 1px rgba(236, 224, 215, 0.6784);
		font-size: 36px;
		color: #fff;
		border-radius: 40px;
	}
</style>